module.exports = __webpack_public_path__ + "img/quest_icon_0027_clan.8d289d38.png";